import { render, staticRenderFns } from "./ChartResultadoxPromedio.vue?vue&type=template&id=b210b568&"
import script from "./ChartResultadoxPromedio.vue?vue&type=script&lang=js&"
export * from "./ChartResultadoxPromedio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports